module.exports = __webpack_public_path__ + "img/1A12C3820DA9CBD5.24d3d3ad.png";